import { useEffect } from 'react';

const UmamiAnalytics = () => {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = process.env.REACT_APP_UMAMI_DASHBOARD_URL; // replace with yours
        script.async = true;
        script.defer = true;
        script.dataset.websiteId = process.env.REACT_APP_UMAMI_WEBSITE_ID;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script); // clean up
        };
    }, []);

    return null;
};

export default UmamiAnalytics;
